/**
 * Keeps the "already in your cart" state of the complementary product rows in sync with the cart.
 *
 * The rows are rendered server-side with the cart state at render time, so the first paint is already
 * correct. This script covers everything that happens afterwards: adding from the row itself, adding
 * or removing the same product elsewhere on the page, and cart drawer quantity changes.
 */
(function () {
  const ROW_SELECTOR = '.complementary-product[data-product-id]';

  function quantitiesByProduct(cart) {
    const quantities = new Map();

    ((cart && cart.items) || []).forEach(function (item) {
      const key = String(item.product_id);
      quantities.set(key, (quantities.get(key) || 0) + item.quantity);
    });

    return quantities;
  }

  function apply(quantities) {
    document.querySelectorAll(ROW_SELECTOR).forEach(function (row) {
      const quantity = quantities.get(row.dataset.productId) || 0;
      const wasInCart = row.classList.contains('is-in-cart');

      row.classList.toggle('is-in-cart', quantity > 0);

      const counter = row.querySelector('.complementary-product__add-count');
      if (counter) {
        counter.textContent = quantity;
        counter.hidden = quantity < 2;
      }

      const button = row.querySelector('.complementary-product__add');
      if (button && quantity > 0 && !wasInCart) {
        button.classList.add('is-just-added');
        button.addEventListener(
          'animationend',
          function () {
            button.classList.remove('is-just-added');
          },
          { once: true }
        );
      }
    });
  }

  let inFlight = null;

  function reconcileWithServer() {
    if (inFlight) return inFlight;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    inFlight = fetch(root + 'cart.js', { priority: 'low' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        apply(quantitiesByProduct(cart));
      })
      .catch(function () {
        /* Leave the server-rendered state in place if the cart cannot be read. */
      })
      .finally(function () {
        inFlight = null;
      });

    return inFlight;
  }

  document.documentElement.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      apply(quantitiesByProduct(event.detail.cart));
    } else {
      reconcileWithServer();
    }
  });

  document.addEventListener('cart:refresh', reconcileWithServer);

  /**
   * The panel is injected by <product-recommendations> after the page has loaded, and that response
   * may come from the browser cache, so reconcile once the markup is actually connected.
   */
  if (!window.customElements.get('complementary-products')) {
    window.customElements.define(
      'complementary-products',
      class ComplementaryProducts extends HTMLElement {
        connectedCallback() {
          reconcileWithServer();
        }
      }
    );
  }
})();
